module.exports = __webpack_public_path__ + "static/img/zxbj-mini.77f60c54.png";